import { render, staticRenderFns } from "./disease_symptom_page.vue?vue&type=template&id=694371d3&scoped=true"
import script from "./disease_symptom_page.vue?vue&type=script&lang=js"
export * from "./disease_symptom_page.vue?vue&type=script&lang=js"
import style0 from "./disease_symptom_page.vue?vue&type=style&index=0&id=694371d3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694371d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694371d3')) {
      api.createRecord('694371d3', component.options)
    } else {
      api.reload('694371d3', component.options)
    }
    module.hot.accept("./disease_symptom_page.vue?vue&type=template&id=694371d3&scoped=true", function () {
      api.rerender('694371d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/disease_symptom_page.vue"
export default component.exports